// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p[data-v-f13f3b22]{margin-bottom:0px}a[data-v-f13f3b22]{color:#ffc833}\n", ""]);
// Exports
module.exports = exports;
